<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-17 19:50:15
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceRecord\AttendanceRecord.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-01 11:03:57
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_attendanceRecord_list_title')"
    @activated="activated"
    filterable
    pad="0"
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <template v-slot:nav-actions>
      <v-tooltip
        bottom
        v-if="viewMode == 0 && hasBtn('unlock-admin-attendance-record')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2 text-capitalize primary"
            color="white"
            :loading="lockloading"
            v-bind="attrs"
            v-on="on"
            icon
            width="36"
            height="36"
            @click="batchLock(0)"
          >
            <i class="material-icons-round">lock_open</i>
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_attendanceRecord_list_tools_batchUnLockTip")
        }}</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="viewMode == 0 && hasBtn('lock-admin-attendance-record')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2 text-capitalize primary"
            color="white"
            icon
            v-bind="attrs"
            width="36"
            height="36"
            v-on="on"
            :loading="lockloading2"
            @click="batchLock(1)"
          >
            <i class="material-icons-round">lock</i>
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_attendanceRecord_list_tools_batchLockTip")
        }}</span>
      </v-tooltip>
      <v-btn
        color="white"
        v-if="hasBtn('recalculate-admin-attendance-record')"
        class="text-capitalize mr-2 primary"
        depressed
        @click="showRecalcul = true"
        rounded
        >{{ $t("label_essweb_RosterRecord_list_recalulateBtnLabel") }}</v-btn
      >
      <v-btn
        rounded
        color="primary mr-2 text-capitalize"
        v-if="curTab == 'tab-1' && hasBtn('export-admin-attendance-record')"
        @click="
          $confirmWarn(
            $t('label_Download_the_CVS'),
            $t('message_essweb_system_operation_export_outLabel'),
            null,
            $t('message_essweb_system_operation_export_exportOutLabel')
          ).then((res) => {
            if (res) exportOut(viewMode);
          })
        "
      >
        {{ $t("label_Download_the_CVS") }}
      </v-btn>
    </template>
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <v-btn-toggle
        v-model="viewMode"
        mandatory
        borderless
        style="height: 36px !important; padding: 1px"
        class="
          text-capitalize
          rounded-lg
          grey
          lighten-2
          mr-3
          d-flex
          align-center
        "
        active-class=" elevation-3 rounded-lg "
      >
        <v-btn
          small
          height="36"
          class="text-capitalize spe_btn text-button"
          :color="
            viewMode == 0
              ? 'white primary--text'
              : 'grey lighten-2 text--secondary'
          "
        >
          <span class="material-icons">reorder</span>
        </v-btn>
        <v-btn
          height="36"
          small
          class="text-capitalize spe_btn text-button"
          :color="
            viewMode == 1
              ? 'white primary--text'
              : 'grey lighten-2 text--secondary'
          "
        >
          <span class="material-icons-round">view_module</span>
        </v-btn>
      </v-btn-toggle>
      <v-spacer></v-spacer>
      <div v-show="viewMode == 0">
        <Selections2
          @close="filterable = !filterable"
          :objects="filterObjects"
          small-chip
          @filter="
            filter();
            toFilter(1, filter);
          "
          @update="
            (prop, value, selected) => {
              $fliterValue(filterObjects, prop, value, selected);
            }
          "
          @reset="
            (apply) => {
              $fliterValue(filterObjects, null, null);
              if (apply) {
                filter();
                toFilter(1, filter);
              }
            }
          "
        />
      </div>
      <div v-show="viewMode == 1">
        <Selections2
          @close="filterable = !filterable"
          :objects="filterObjects2"
          small-chip
          @filter="
            filter();
            toFilter(2, filter);
          "
          @update="
            (prop, value, selected) => {
              if (prop == 'department') curDept = value; //触发岗位更新下拉
              $fliterValue(filterObjects2, prop, value, selected);
            }
          "
          @reset="
            (apply) => {
              $fliterValue(filterObjects2, null, null);
              if (apply) {
                filter();
                toFilter(2, filter);
              }
            }
          "
        />
      </div>
    </template>
    <template v-slot:page-main>
      <!-- <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        needScrollX
        :contentBackground="curTab == 'tab-1' ? 'white' : 'mrc-grey pa-0'"
      >
        <template v-slot:content-1> -->
      <Tabler
        v-show="viewMode == 0"
        :headers="headers"
        :items="desserts"
        @select="onSelect"
        :defaultSelect="selected"
        :showSelect="showSelect && !isLoading"
        :filter-page-data="filterPageData"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
        overLoading
      >
        <!-- <template v-slot:header.schedule_setime="{ header }">
          <div
            class="align-center d-flex flex-column transparent"
            :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
          >
            <div class="d-flex align-center transparent">
              <v-chip
                small
                class="
                  ma-auto
                  align-center
                  text-center
                  d-inline-block
                  text-truncate
                "
                color="gery lighten-4"
                :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
                style="
                  display: block;
                  color: rgba(0, 0, 0, 0.87);
                  font-weight: normal;
                "
              >
                <div class="d-inline-block text-truncate" :title="header.text">
                  {{ header.text }}
                </div>
              </v-chip>
            </div>
            <div
              :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
              class="d-flex px-3 text-body-2 text-truncate transparent"
            >
              {{ $t("label_essweb_attendanceRecord_list_startLabel") }}
              <v-spacer></v-spacer>
              {{ $t("label_essweb_attendanceRecord_list_endLabbel") }}
            </div>
          </div>
        </template>

        <template v-slot:header.official_IO="{ header }">
          <div
            class="align-center d-flex flex-column transparent"
            :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
          >
            <div class="d-flex align-center transparent">
              <v-chip
                small
                class="
                  ma-auto
                  align-center
                  text-center
                  d-inline-block
                  text-truncate
                "
                color="gery lighten-3"
                :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
                style="
                  display: block;
                  color: rgba(0, 0, 0, 0.87);
                  font-weight: normal;
                "
                ><div class="d-inline-block text-truncate" :title="header.text">
                  {{ header.text }}
                </div></v-chip
              >
            </div>
            <div
              :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
              class="d-flex px-3 text-body-2 transparent"
            >
              {{ $t("label_essweb_attendanceRecord_list_inLabel") }}
              <v-spacer></v-spacer>
              {{ $t("label_essweb_attendanceRecord_list_outLabbel") }}
            </div>
          </div>
        </template>
        <template v-slot:header.official_setime="{ header }">
          <div
            class="align-center d-flex flex-column transparent"
            :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
          >
            <div class="d-flex align-center transparent">
              <v-chip
                small
                class="
                  ma-auto
                  align-center
                  text-center
                  d-inline-block
                  text-truncate
                "
                color="gery lighten-3"
                :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
                style="
                  display: block;
                  color: rgba(0, 0, 0, 0.87);
                  font-weight: normal;
                "
                ><div class="d-inline-block text-truncate" :title="header.text">
                  {{ header.text }}
                </div></v-chip
              >
            </div>
            <div
              :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
              class="d-flex px-3 text-body-2 transparent"
            >
              {{ $t("label_essweb_attendanceRecord_list_startLabel") }}
              <v-spacer></v-spacer>
              {{ $t("label_essweb_attendanceRecord_list_endLabbel") }}
            </div>
          </div>
        </template>
        <template v-slot:header.actual="{ header }">
          <div
            class="align-center d-flex flex-column transparent"
            :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
          >
            <div class="d-flex align-center">
              <v-chip
                small
                color="gery lighten-2"
                class="
                  ma-auto
                  align-center
                  text-center
                  d-inline-block
                  text-truncate
                "
                :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
                style="
                  display: block;
                  color: rgba(0, 0, 0, 0.87);
                  font-weight: normal;
                "
                ><div class="d-inline-block text-truncate" :title="header.text">
                  {{ header.text }}
                </div></v-chip
              >
            </div>
            <div
              :style="{ width: defaultLang === 'en' ? '124px' : '100px' }"
              class="d-flex px-3 text-body-2 transparent"
            >
              {{ $t("label_essweb_attendanceRecord_list_inLabel") }}
              <v-spacer></v-spacer>
              {{ $t("label_essweb_attendanceRecord_list_outLabbel") }}
            </div>
          </div>
        </template> -->
        <!--  -->
        <template v-slot:item.date="{ item }">
          <div class="table-title text--primary">
            {{ $getDateTime(item.utc_att_date, "YYYY/MM/DD") }}
          </div>
        </template>
        <template v-slot:item.staff="{ item }">
          <div style="max-width: 300px">
            <v-list-item dense two-line class="pa-0 ma-0">
              <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                <StaffAvatar
                  size="36"
                  :isTemp="item.is_temp"
                  :src="item.staff_avatar"
                  :staff_name="item.preferred_name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  >{{ $getCommonLangValue(item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">
                    {{ item.staff_code }}</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  $getCommonLangValue(item.job_post_name)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:item.schedule_shift="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.schedule_shift_name) }}
          </div>
        </template>
        <template v-slot:item.site_name="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.site_name) }}
          </div>
        </template>
        <template v-slot:item.cost_center="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.cost_center_name) }}
          </div>
        </template>
        <template v-slot:item.official_shift="{ item }">
          <div class="table-title text--primary">
            {{ $getCommonLangValue(item.official_shift_name) }}
          </div>
        </template>
        <template v-slot:item.tag="{ item }">
          <div style="max-width: 200px" class="d-flex flex-wrap justify-start">
            <v-chip
              small
              v-if="Number(item.is_late)"
              :color="$getTagColors($card_line_colors, 'is_late_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_lateLabel") }}({{
                item.official_total_late_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_ot)"
              :color="$getTagColors($card_line_colors, 'is_ot_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_otLabel") }}({{
                item.official_total_ot_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_early_leave)"
              :color="$getTagColors($card_line_colors, 'is_early_leave_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_earlyLeaveLabel") }}({{
                item.official_total_early_leave_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_absense)"
              :color="$getTagColors($card_line_colors, 'is_absense_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_absenseLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_work_from_home)"
              :color="$getTagColors($card_line_colors, 'is_work_from_home_1')"
              class="ma-1 text--primary"
              >{{
                $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_locked)"
              :color="$getTagColors($card_line_colors, 'is_locked_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_isLockedLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_adhoc)"
              :color="$getTagColors($card_line_colors, 'is_adhoc_1')"
              class="ma-1 text--primary"
              >{{ $t("label_essweb_system_tag_label_isAdhocLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_missing_punch)"
              :color="$getTagColors($card_line_colors, 'is_missing_punch_1')"
              class="ma-1 white--text"
              >{{
                $t("label_essweb_system_tag_label_isMissingPunchLabel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_out_of_office)"
              :color="$getTagColors($card_line_colors, 'is_out_of_office_1')"
              class="ma-1 text--primary"
              >{{
                $t("label_essweb_system_tag_label_isOutOfOfficeLabel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_onDuty)"
              :color="$getTagColors($card_line_colors, 'is_on_duty_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_isOnDutyLabel") }}</v-chip
            >
            <v-chip
              small
              outlined
              :color="leave.color_code"
              v-for="(leave, index) in item.leave_info"
              :key="`leave--${index}`"
              class="ma-1"
              >{{ $getCommonLangValue(leave["leave_type_name"]) }}</v-chip
            >
            <v-chip
              small
              :color="$getTagColors($card_line_colors, 'is_holiday_1')"
              v-for="(holiday, index) in item.holiday_info"
              :key="`holiday--${index}`"
              class="ma-1 text--primary"
              >{{ $getCommonLangValue(holiday["holiday_name"]) }}</v-chip
            >
          </div>
        </template>
        <template v-slot:item.schedule_setime="{ item }">
          <div class="d-flex flex-column text-truncate">
            <span>{{
              $getDateTime(item.schedule_start_utc_time, "HH:mm")
            }}</span>
            <v-divider
              style="width: 90%"
              class="mx-auto mrc-border-dashed"
            ></v-divider>
            <span>{{ $getDateTime(item.schedule_end_utc_time, "HH:mm") }}</span>
          </div>
        </template>

        <template v-slot:item.official_setime="{ item }">
          <div class="d-flex flex-column text-truncate">
            <span>{{
              $getDateTime(item.official_start_utc_time, "HH:mm")
            }}</span>
            <v-divider
              style="width: 90%"
              class="mx-auto mrc-border-dashed"
            ></v-divider>
            <span>{{ $getDateTime(item.official_end_utc_time, "HH:mm") }}</span>
          </div>
        </template>
        <template v-slot:item.official_IO="{ item }">
          <div class="d-flex flex-column text-truncate">
            <span>{{
              $getDateTime(item.official_punch_in_utc_datetime, "HH:mm")
            }}</span>
            <v-divider
              style="width: 90%"
              class="mx-auto mrc-border-dashed"
            ></v-divider>
            <span>{{
              $getDateTime(item.official_punch_out_utc_datetime, "HH:mm")
            }}</span>
          </div>
        </template>
        <template v-slot:item.actual="{ item }">
          <div class="d-flex flex-column text-truncate">
            <span>{{
              $getDateTime(item.actual_punch_in_utc_datetime, "HH:mm")
            }}</span>
            <v-divider
              style="width: 90%"
              class="mx-auto mrc-border-dashed"
            ></v-divider>
            <span>
              {{ $getDateTime(item.actual_punch_out_utc_datetime, "HH:mm") }}
            </span>
          </div>
        </template>
        <template v-slot:item.official_work_minutes="{ item }">
          <div class="table-title text--primary">
            {{ item.official_working_minutes || 0 }}
          </div>
        </template>
        <template v-slot:item.official_late_minutes="{ item }">
          <div class="table-title text--primary">
            {{ item.official_total_late_minutes || 0 }}
          </div>
        </template>
        <template v-slot:item.official_earlyleave_minutes="{ item }">
          <div class="table-title text--primary">
            {{ item.official_total_early_leave_minutes || 0 }}
          </div>
        </template>
        <template v-slot:item.official_ot_minutes="{ item }">
          <div class="table-title text--primary">
            {{ item.official_total_ot_minutes || 0 }}
          </div>
        </template>
        <template v-slot:item.official_absense_minutes="{ item }">
          <div class="table-title text--primary">
            {{ $timeMachine(item.official_absense_minutes || 0) }}
          </div>
        </template>
        <template v-slot:item.official_before_minutes="{ item }">
          <div class="table-title text--primary">
            {{ $timeMachine(item.official_before_work_minutes || 0) }}
          </div>
        </template>
        <template v-slot:item.official_after_minutes="{ item }">
          <div class="table-title text--primary">
            {{ $timeMachine(item.official_after_work_minutes || 0) }}
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <!-- 2020-09-18暂无UI -->
          <!-- 2021-07-20 brain 加上详情  -->
          <v-btn
            icon
            @click="toView(item.uuid)"
            v-if="hasBtn('view-admin-attendance-record')"
          >
            <svg-icon size="24" fill="currentColor" iconClass="viewDetail" />
          </v-btn>
          <!-- <tableListTools
                :uuid="item.uuid"
                delBtn
                editBtn
                title="Attendance Record"
                @delete="toDelete"
                @edit="toEdit"
              />-->
        </template>
      </Tabler>
      <!-- </template>
        <template v-slot:content-2>
          <v-sheet class="d-flex pt-1 pb-3 mrc-grey">
            <v-spacer></v-spacer>
            <v-btn-toggle
              v-model="timeselect"
              mandatory
              borderless
              style="height: 32px !important; padding: 2px"
              class="text-capitalize rounded-lg grey lighten-2"
              active-class=" elevation-3 rounded-lg "
            >
              <v-btn
                width="67"
                small
                class="text--primary text-capitalize spe_btn mr-1 rounded"
                :color="timeselect == 0 ? 'white' : 'grey lighten-2'"
                >{{ $t("label_essweb_attendanceRecord_list_dayLabbel") }}</v-btn
              >
              <v-btn
                small
                width="67"
                class="text--primary text-capitalize spe_btn ml-1 mr-1 rounded"
                :color="timeselect == 1 ? 'white' : 'grey lighten-2'"
                >{{
                  $t("label_essweb_attendanceRecord_list_weekLabbel")
                }}</v-btn
              >
              <v-btn
                width="67"
                small
                class="text--primary text-capitalize spe_btn ml-1 rounded"
                :color="timeselect == 2 ? 'white' : 'grey lighten-2'"
                >{{
                  $t("label_essweb_attendanceRecord_list_monthLabbel")
                }}</v-btn
              >
            </v-btn-toggle>
          </v-sheet>
          <v-card class="pa-3 rounded-lg" :elevation="0">
            <Tabler
              :headers="headers2"
              :items="desserts2"
              :showSelect="showSelect"
              :totalCount="totalCount2"
              @change="
                (page, perpage, callback) => {
                  Statistics(page, perpage, callback);
                }
              "
            >
              <template v-slot:top>
               
              </template>
              <template v-slot:item.totalw="{ item }">
                <div class="table-title text--primary">
                  {{ item.total_working || 0 }}
                </div>
              </template>
              <template v-slot:item.totalot="{ item }">
                <div class="table-title text--primary">
                  {{ item.total_ot || 0 }}
                </div>
              </template>
              <template v-slot:item.totalleave="{ item }">
                <div class="table-title text--primary">
                  {{ $timeMachine(item.total_leave || 0) }}
                </div>
              </template>
              <template v-slot:item.totallate="{ item }">
                <div class="table-title text--primary">
                  {{ item.total_late || 0 }}
                </div>
              </template>
              <template v-slot:item.totaler="{ item }">
                <div class="table-title text--primary">
                  {{ item.total_early_leave || 0 }}
                </div>
              </template>
              <template v-slot:item.date="{ item }">
                <div class="table-title text--primary">{{ curDate }}</div>
              </template>
              <template v-slot:item.staff="{ item }">
                <div style="max-width: 300px">
                  <v-list-item dense two-line class="pa-0 ma-0">
                    <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                      <StaffAvatar
                        size="36"
                        :src="item.staff_avatar"
                        :staff_name="item.preferred_name"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $getCommonLangValue(item.preferred_name)
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        $getCommonLangValue(item.job_post_name)
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </template>
            </Tabler>
          </v-card>
        </template>
      </Taber> -->
      <!-- 格子视图 -->
      <AttendancePlan
        v-show="viewMode == 1"
        :cycleType="cycleType"
        @reset="
          (e) => {
            if (e) $fliterValue(filterObjects2, null, null);
          }
        "
        :startTime="startTime"
        :iSEdited="iSEdited"
        :selectStartDate="startDate"
        :selectEndDate="endDate"
        :filter-data="filterData"
        :endTime="endTime"
        @onTrigerPage="
          (logic, time) => {
            toResetTime(logic, time);
          }
        "
        @onShift="
          (data, dete, master) => {
            toView(master['uuid']);
          }
        "
      />
      <!-- 格子视图/ -->
    </template>
    <template v-slot:tools-main>
      <!-- Recalculate -->
      <RecalculateDialog
        :show="showRecalcul"
        :curStaffs="allStaff"
        @close="showRecalcul = false"
        @onSave="toReCalGen"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import AttendancePlan from "@/Page/EssAdmin/Attendance/AttendanceRecord/components/AttendancePlan";
import RecalculateDialog from "@/Page/EssAdmin/Roster/RosterRecord/components/RecalculateDialog";
import dayjs from "dayjs";
export default {
  name: "AttendanceRecord",
  components: { RecalculateDialog, AttendancePlan },
  computed: {
    ...mapGetters(["defaultLang", "isLoading"]),
    curDate() {
      return this.timeselect == 0
        ? dayjs().format("YYYY/MM/DD")
        : this.timeselect == 1
        ? dayjs().startOf("week").format("YYYY/MM/DD") +
          " - " +
          dayjs().endOf("week").format("YYYY/MM/DD")
        : this.timeselect == 2
        ? dayjs().startOf("month").format("YYYY/MM/DD") +
          " - " +
          dayjs().endOf("month").format("YYYY/MM/DD")
        : "";
    },
  },
  data() {
    return {
      filterData: null,
      showSelect: true,
      cycleType: 14,
      search: "",
      timeselect: 0,
      curDept: [],
      showRecalcul: false,
      iSEdited: true,
      startTime: "1970-01-01",
      endTime: "1970-01-31",
      filterable: false,
      totalCount: 0,
      totalCount2: 0,
      startDate: "",
      viewMode: 0,
      endDate: "",
      filterPageData: null,
      page: null,
      pagesize: null,
      curTab: "tab-1",
      taber: [
        "label_essweb_attendanceRecord_list_tab_attendanceLabel",
        "label_essweb_attendanceRecord_list_tab_statisticsLabel",
      ],
      headers: [
        {
          text: "label_essweb_attendanceRecord_list_dateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_staffLabel",
          value: "staff",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_tagLabel",
          value: "tag",
          width: 150,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_scheduleShiftLabel",
          value: "schedule_shift",
          mrcSelected: false,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_siteNameLabel",
          value: "site_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_costCentreLabel",
          value: "cost_center",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_scheduleSETimeLabbel",
          value: "schedule_setime",
          align: "center",
          width: 100,
          mrcSelected: false,
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialShiftLabel",
          value: "official_shift",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialSELabbel",
          value: "official_setime",
          align: "center",
          width: 100,
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialIOTimeLabbel",
          value: "official_IO",
          width: 100,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_actualLabbel",
          value: "actual",
          mrcSelected: false,
          width: 100,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialWorkingMinutesLabel",
          value: "official_work_minutes",
          width: 100,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalBeforeWorkLabel",
          value: "official_before_minutes",
          width: 100,
          align: "center",
          mrcSelected: false,
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalAfterWorkLabel",
          value: "official_after_minutes",
          width: 100,
          align: "center",
          mrcSelected: false,
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialLateMinutesLabel",
          value: "official_late_minutes",
          mrcSelected: true, //2020-05-19 改为默认显示 brain
          width: 100,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialEarlyLeaveMinutesLabel",
          value: "official_earlyleave_minutes",
          width: 100,
          align: "center",
          mrcSelected: true, //2020-05-19 改为默认显示 brain
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_officialOTMinutesLabel",
          value: "official_ot_minutes",
          width: 100,
          align: "center",
          mrcSelected: true, //2020-05-19 改为默认显示 brain
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalAbsenseLabel",
          value: "official_absense_minutes",
          width: 100,
          align: "center",
          mrcSelected: true,
          sortable: false,
        },

        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      headers2: [
        {
          text: "label_essweb_attendanceRecord_list_dateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_staffLabel",
          value: "staff",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalWorkingLabbel",
          value: "totalw",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalOTLabbel",
          value: "totalot",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalLateLabbel",
          value: "totallate",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceRecord_list_totalEarlyLeaveLabbel",
          value: "totaler",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceModifiApp_form_totalLeaveLabel",
          value: "totalleave",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      allStaff: [],
      selected: [],
      lockloading2: false,
      lockloading: false,
      desserts2: [],
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          avatar: true,
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 1,
          name: "date",
          position: "right",
          label: "label_essweb_attendanceRecord_list_dateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: null,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "shift_name",
          name: "shift",
          multiple: true,
          label: "label_essweb_attendanceRecord_list_officialShiftLabel",
          value: [],
          selected: [],
          data: {
            api: "/attendance-master/get-shift-select/",
            url_type: "primary",
            args: null,
            table: "ess_att_attendance_master",
            type: "",
            modelKey: "shift_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          name: "site",
          multiple: true,
          label: "label_essweb_attendanceRecord_list_siteNameLabel",
          value: "",

          selected: [],
          data: {
            api: "ess_site_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 5,
          position: "right",
          name: "cost_center",
          multiple: true,
          label: "label_essweb_ClaimRecord_form_dialog_costCentreLabel",
          value: "",

          selected: [],
          data: {
            api: "ess_cost_center_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 4,
          position: "right",
          showKey: "dict_label",
          name: "tag",
          multiple: true,
          label: "label_essweb_approvalProcess_list_statusLabel",
          value: [],
          selected: [],
          data: {
            api: "/attendance-master/get-tag-select/",
            url_type: "primary",
            args: null,
            table: "ess_att_attendance_master",
            type: "",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
      filterObjects2: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],

          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "client",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],
          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "client",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  watch: {
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects2, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects2[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects2[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects2[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
    timeselect(val) {
      this.desserts2 = [];
      if (val === 0) {
        this.getStatisticsList(
          new Date(dayjs().format("YYYY-MM-DD")).getTime(),
          new Date().getTime(dayjs().format("YYYY-MM-DD")),
          1,
          this.$tableSetting.perPageSize,
          () => {
            this.$store.dispatch("resetTable", new Date().getTime());
          }
        );
      }
      if (val === 1) {
        this.getStatisticsList(
          new Date(dayjs().startOf("week").format("YYYY-MM-DD")).getTime(),
          new Date(dayjs().endOf("week").format("YYYY-MM-DD")).getTime(),
          1,
          this.$tableSetting.perPageSize,
          () => {
            this.$store.dispatch("resetTable", new Date().getTime());
          }
        );
      }
      if (val === 2) {
        this.getStatisticsList(
          new Date(dayjs().startOf("month").format("YYYY-MM-DD")).getTime(),
          new Date(dayjs().endOf("month").format("YYYY-MM-DD")).getTime(),
          1,
          this.$tableSetting.perPageSize,
          () => {
            this.$store.dispatch("resetTable", new Date().getTime());
          }
        );
      }
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.startTime = this.resettingTime()[0];
    this.endTime = this.resettingTime()[1];
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
    //2021-07-08 brain 去掉考勤
    // this.getStatisticsList(
    //   new Date(dayjs().format("YYYY-MM-DD")).getTime(),
    //   new Date().getTime(dayjs().format("YYYY-MM-DD")),
    //   1,
    //   this.$tableSetting.perPageSize,
    //   null
    // );
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(2, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    //  重设时间
    resettingTime: function (start, logic = "add") {
      let end = "";
      if (!start) {
        start = dayjs().format("YYYY-MM-DD");
        if (logic == "add") {
          end = dayjs()
            .add(this.cycleType - 1, "day")
            .format("YYYY-MM-DD");
          return [start, end];
        }
        if (logic == "red") {
          end = dayjs().subtract(this.cycleType, "day").format("YYYY-MM-DD");
          return [end, start];
        }
      } else {
        start = dayjs(start).format("YYYY-MM-DD");
        if (logic == "add") {
          end = dayjs(start)
            .add(this.cycleType - 1, "day")
            .format("YYYY-MM-DD");
          return [start, end];
        }
        if (logic == "red") {
          end = dayjs(start)
            .subtract(this.cycleType, "day")
            .format("YYYY-MM-DD");
          return [end, start];
        }
      }
    },
    toResetTime: function (logic, time) {
      let start = this.startTime;
      let end = this.endTime;
      if (!logic) {
        this.startTime = this.resettingTime()[0];
        this.endTime = this.resettingTime()[1];
      } else {
        if (logic == "add") {
          if (time) {
            this.startTime = this.resettingTime(time, "add")[0];
            this.endTime = this.resettingTime(time, "add")[1];
          } else {
            this.startTime = this.resettingTime(end, "add")[0];
            this.endTime = this.resettingTime(end, "add")[1];
          }
        } else {
          this.startTime = this.resettingTime(start, "red")[0];
          this.endTime = this.resettingTime(start, "red")[1];
        }
      }
    },
    batchLock(lock) {
      const that = this;
      if (this.selected.length == 0) return;
      let uuids = [];
      this.selected.map((item) => {
        uuids.push(item.uuid);
      });
      lock ? (this.lockloading2 = true) : (this.lockloading = true);
      let url = lock
        ? "/attendance-master/batch-lock/"
        : "/attendance-master/batch-unlock/";
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: url,
        data: { uuids: uuids.join(",") },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: lock
            ? that.$t(
                "message_essweb_attendanceRecord_list_batchLockSuccessLabel"
              )
            : that.$t(
                "message_essweb_attendanceRecord_list_batchUnLockSuccessLabel"
              ),
        });
        that.getList(null, 1, that.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    onSelect(items) {
      this.selected = items;
    },
    toReCalGen: function (staffs, start, end) {
      const that = this;
      let url = "";

      url = "/roster/recalculate/";
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: url,
        data: {
          staff_uuids: staffs.join(","),
          start_time: this.$getTimeValue(start),
          end_time: this.$getTimeValue(end),
        },
      }).then((res) => {
        that.$showMessage({
          color: "black",
          text:
            that.toDo == "regenerate"
              ? that.$t(
                  "message_essweb_rosterRecord_form_dialog_rosterGenerateInitSuccessLabel"
                )
              : that.$t(
                  "message_essweb_rosterRecord_form_dialog_rosterRecalculateSuccessLabel"
                ),
          type: "success",
        });
        that.showRecalcul = false;
        that.getList(null, 1, that.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    toView: function (uuid) {
      this.$toPage(
        "/admin/attendance-record/detail/" +
          this.$aesEncrypt(
            JSON.stringify({
              id: uuid,
            })
          )
      );
    },
    exportOut(mode) {
      const that = this;
      let object = [];
      if (mode == 0)
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      if (mode == 1)
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "shift")
          data["shift_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "site") {
          data["site_uuid"] = item.value.join(",");
        }
        if (item["name"] == "cost_center") {
          data["cost_center_uuid"] = item.value.join(",");
        }
        if (item["name"] == "tag") {
          data["tags"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/exports/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_attendanceRecord_list_title"),
      });
    },
    Statistics(page, perpage, callback) {
      this.desserts2 = [];
      if (this.timeselect === 0) {
        this.getStatisticsList(
          new Date(dayjs().format("YYYY-MM-DD")).getTime(),
          new Date().getTime(dayjs().format("YYYY-MM-DD")),
          page,
          perpage,
          callback
        );
      }
      if (this.timeselect === 1) {
        this.getStatisticsList(
          new Date(dayjs().startOf("week").format("YYYY-MM-DD")).getTime(),
          new Date(dayjs().endOf("week").format("YYYY-MM-DD")).getTime(),
          page,
          perpage,
          callback
        );
      }
      if (this.timeselect === 2) {
        this.getStatisticsList(
          new Date(dayjs().startOf("month").format("YYYY-MM-DD")).getTime(),
          new Date(dayjs().endOf("month").format("YYYY-MM-DD")).getTime(),
          page,
          perpage,
          callback
        );
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      if (tab === 1)
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      if (tab === 2)
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );

      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "shift")
          data["shift_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "site") {
          data["site_uuid"] = item.value.join(",");
        }
        if (item["name"] == "cost_center") {
          data["cost_center_uuid"] = item.value.join(",");
        }
        if (item["name"] == "tag") {
          data["tags"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      if (tab == 1) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else if (tab == 2) {
        this.filterData = data;
      } else {
        this.filterData = null;
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (page !== 1) this.page = page;
      else this.page = null;
      if (perpage !== this.$tableSetting.perPageSize) this.pagesize = perpage;
      else this.pagesize = null;
      this.selected = [];
      this.lockloading2 = false;
      this.lockloading = false;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      })
        .then((res) => {
          that.desserts = res.data;
          that.totalCount = res.totalcount;
          callback ? callback(page, perpage, data) : null;
        })
        .catch(() => {
          callback ? callback(page, perpage, data) : null;
        });
    },
    getStatisticsList: function (sdate, edate, page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/get-statistics/",
        data: {
          start_date: sdate,
          end_date: edate,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.desserts2 = res.data;
        that.totalCount2 = res.totalcount;
        callback
          ? callback(page, perpage, {
              start_date: sdate,
              end_date: edate,
            })
          : null;
      });
    },
  },
};
</script>
<style scoped>
.spe_btn::before {
  background-color: inherit !important;
}
.text-body-2 {
  color: rgba(0, 0, 0, 0.38) !important;
}
</style>
